module.exports = __webpack_public_path__ + "static/img/ico_twitter.362ce54.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/images/ico/ico_twitter.svg
// module id = yvFj
// module chunks = 0